export default {
    label_task:{
        en:"Dealers Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Dealer Sales",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Dealer Sales",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Dealer Sales",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_sales_at:{
        en:"Sales Entry Time",
        bn:"কর্মচারী আইডি"
    },

}